import { createSlice, type PayloadAction, type WithSlice } from '@reduxjs/toolkit';

import { DATAGRID_INITIAL_PAGE, DATAGRID_INITIAL_PAGE_SIZE } from '../../../common/constants';
import { rootReducer } from '../../../lib/store';

export interface SupervisorProjectState {
  projectsListPage: number;
  projectsListPageSize: number;
}

const initialState: SupervisorProjectState = {
  projectsListPage: DATAGRID_INITIAL_PAGE,
  projectsListPageSize: DATAGRID_INITIAL_PAGE_SIZE,
};

const supervisorProjectSlice = createSlice({
  name: 'supervisorProject',
  initialState,
  reducers: {
    setProjectsListPaginationModel: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>
    ) => {
      state.projectsListPage = action.payload.page;
      state.projectsListPageSize = action.payload.pageSize;
    },
  },
});

export const { setProjectsListPaginationModel } = supervisorProjectSlice.actions;

declare module '../../../lib/store' {
  // WithSlice utility assumes reducer is under slice.reducerPath
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof supervisorProjectSlice> {}
}

supervisorProjectSlice.injectInto(rootReducer);

export { supervisorProjectSlice };
